// extracted by mini-css-extract-plugin
export default {"forgotPasswordWrapper":"ForgotPassword_forgotPasswordWrapper__+svw2","formWrapper":"ForgotPassword_formWrapper__yXeiw"};